import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-subhead-table',
  templateUrl: './subhead-table.component.html',
  styleUrls: ['./subhead-table.component.scss'],
  imports: [MatIconModule, CommonModule],
})
export class SubheadTableComponent {
  @Input() subHead;
  @Input() products;
}
